import { apiSlice } from '../api/apiSlice';

export const reportApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getShopReportOwnerReply: builder.query({
      query: ({ shopId, reportId }) => ({
        url: '/reportshop/getownerreply',
        params: { shopId, reportId },
      }),
    }),
    getServiceReportOwnerReply: builder.query({
      query: ({ serviceId, reportId }) => ({
        url: '/reportservice/getownerreply',
        params: { serviceId, reportId },
      }),
    }),
  }),
});

export const {
  useLazyGetShopReportOwnerReplyQuery,
  useLazyGetServiceReportOwnerReplyQuery,
} = reportApiSlice;
